import { render, staticRenderFns } from "./QAmodal.vue?vue&type=template&id=7cff5030&"
import script from "./QAmodal.vue?vue&type=script&lang=js&"
export * from "./QAmodal.vue?vue&type=script&lang=js&"
import style0 from "./QAmodal.vue?vue&type=style&index=0&scopped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports